import UiModal from '../UiModal/UiModal'
import { Media, MODAL_ACTIVE_CLASSES } from '../../utils/const'
import { setCookie } from '../../utils/cookies'
import { smartPopupInit } from '../SmartPopup'

const CALL_US_POPUP_TIMEOUT = 35 * 1000
const CANCEL_REASON = {
  DEFAULT: 'default',
  FORM_SENT: 'form-sended',
  MEDIA_CHANGE: 'media-change',
  PHONE_CLICK: 'phone-click'
}

class CallUsPopup extends UiModal {
  /**
   * @param {HTMLElement} template
   */
  constructor(template) {
    super(template, { wrapperClass: 'call-us-popup' })

    this.content = template
    this.phoneLinkButton = this.content.querySelector('.call-us-popup__button')

    this._mobileMedia = window.matchMedia(`(max-width: ${Media.SM_MAX}px)`)

    this._initTimeout = null
    this._isSmartPopupHandled = false

    this.handleMediaChange = this.handleMediaChange.bind(this)
    this.phoneLinkButtonClick = this.phoneLinkButtonClick.bind(this)
  }

  handleMediaChange() {
    this.cancel(CANCEL_REASON.DEFAULT, false)

    this.close()
  }

  phoneLinkButtonClick() {
    window.$analytics?.push('phone-link-click', {
      blockName: 'Call us popup',
      label: 'Call us popup phone click'
    })

    this.cancel(CANCEL_REASON.PHONE_CLICK, false)
    this.close()
  }

  start(delay = CALL_US_POPUP_TIMEOUT) {
    this._initTimeout = setTimeout(() => {
      this.show()
    }, delay)
  }

  show() {
    this.cancel(CANCEL_REASON.DEFAULT, false)

    if (document.querySelector(MODAL_ACTIVE_CLASSES)) {
      this.start(CALL_US_POPUP_TIMEOUT)

      return
    }

    this.init()
  }

  cancel(reason = CANCEL_REASON.DEFAULT, shouldInitSmartPopup = true) {
    if (reason === CANCEL_REASON.PHONE_CLICK || reason === CANCEL_REASON.FORM_SENT) {
      this._isSmartPopupHandled = true
      setCookie('smartPopupShowedInSession', window.userSession.session.id, {}, false)
    }

    if (shouldInitSmartPopup && reason !== CANCEL_REASON.PHONE_CLICK && reason !== CANCEL_REASON.FORM_SENT && !this._isSmartPopupHandled) {
      this._isSmartPopupHandled = true
      smartPopupInit()
    }

    clearTimeout(this._initTimeout)
    this._initTimeout = null
  }

  beforeMounted() {
    this._mobileMedia.addEventListener('change', this.handleMediaChange)
    this.phoneLinkButton.addEventListener('click', this.phoneLinkButtonClick)
  }

  beforeUnmounted() {
    this._mobileMedia.removeEventListener('change', this.handleMediaChange)
    this.phoneLinkButton.removeEventListener('click', this.phoneLinkButtonClick)
  }

  unmounted() {
    super.unmounted()

    if (!this._isSmartPopupHandled) {
      this._isSmartPopupHandled = true
      smartPopupInit()
    }
  }
}

export const showCallUsPopup = () => {
  window.$growthbookClient.getFeatureValue('call_us_popup')
  const { value } = window.$growthbookClient.getFeatureValue('call_us_popup')[0]

  if (!value) {
    return false
  }

  const smMax = window.matchMedia(`(max-width: ${Media.SM_MAX}px)`)

  if (!smMax.matches) {
    return false
  }

  const template = document.querySelector('#call-us-popup')?.content
    .cloneNode(true)
    .querySelector('.call-us-popup__wrapper')

  if (!template) {
    const err = new Error(`[Call Us Popup]: шаблон с id=call-us-popup отсутствует`)
    console.error(err)
    window.Sentry?.captureException(err)

    return false
  }

  const callUsPopup = new CallUsPopup(template)

  callUsPopup.start(CALL_US_POPUP_TIMEOUT)

  const handleMediaChangeBeforeMounted = () => {
    callUsPopup.cancel(CANCEL_REASON.MEDIA_CHANGE)

    smMax.removeEventListener('change', handleMediaChangeBeforeMounted)
    document.body.removeEventListener('form-sended', handleFormSendedBeforeMounted)
  }

  const handleFormSendedBeforeMounted = () => {
    callUsPopup.cancel(CANCEL_REASON.FORM_SENT)

    smMax.removeEventListener('change', handleMediaChangeBeforeMounted)
    document.body.removeEventListener('form-sended', handleFormSendedBeforeMounted)
  }

  smMax.addEventListener('change', handleMediaChangeBeforeMounted, { once: true })
  document.body.addEventListener('form-sended', handleFormSendedBeforeMounted, { once: true })

  return true
}
